<template>
	<div>
		<!-- INDIVÍDUOS OU ENTIDADES QUE DETENHAM PARCELA IGUAL OU SUPERIOR A 25% DE PARTICIPAÇÃO -->
		<h3>INDIVÍDUOS OU ENTIDADES QUE DETENHAM PARCELA IGUAL OU SUPERIOR A 25% DE PARTICIPAÇÃO</h3>
		<small>(não se aplica no caso de companhia de capital aberto)</small>
		<owner-form-component
			v-for="(owner, index) in ownerContacts"
			:salesforce-contact-id="owner.id"
			:key="'owner' + index"
			:can-delete="index > 0"
			:form-key="index" />

		<a class="more" @click="$store.dispatch('addContact', 'owner')">+ Adicionar</a>

		<!-- REPRESENTANTE LEGAL - SIGNATÁRIO AUTORIZADO -->
		<h3>REPRESENTANTE LEGAL - SIGNATÁRIO AUTORIZADO</h3>
		<representative-form-component
			v-for="(representative, index) in representativeContacts"
			:salesforce-contact-id="representative.id"
			:key="'representative' + index"
			:can-delete="index > 0"
			:form-key="index" />

		<a class="more" @click="$store.dispatch('addContact', 'representative')">+ Adicionar</a>

		<!-- CONTATO PARA RECEBIMENTO DE NOTIFICAÇÕES REFERENTE AO CONTRATO -->
		<h3>CONTATO PARA RECEBIMENTO DE NOTIFICAÇÕES REFERENTE AO CONTRATO</h3>
		<contract-form-component
			v-for="(contract, index) in contractContacts"
			:salesforce-contact-id="contract.id"
			:key="'contract' + index"
			:can-delete="index > 0"
			:form-key="index" />

		<a class="more" @click="$store.dispatch('addContact', 'contract')">+ Adicionar</a>

		<!-- CONTATO FINANCEIRO -->
		<h3>CONTATO FINANCEIRO</h3>
		<contact-form-component
			v-for="(billing, index) in billingContacts"
			:salesforce-contact-id="billing.id"
			:key="'billing' + index"
			:can-delete="index > 0"
			:form-key="index"
			:hide-full-name="true"
			:hide-phone="true"
			:contact-filtered-list.sync="billingContacts[index]" />

		<a class="more" @click="$store.dispatch('addContact', 'billing')">+ Adicionar</a>

		<!-- CONTATO TÉCNICO -->
		<h3>CONTATO TÉCNICO</h3>
		<contact-form-component
			v-for="(technical, index) in technicalContacts"
			:salesforce-contact-id="technical.id"
			:key="'technical' + index"
			:can-delete="index > 0"
			:form-key="index"
			:hide-full-name="true"
			:hide-phone="true"
			:contact-filtered-list.sync="technicalContacts[index]" />

		<a class="more" @click="$store.dispatch('addContact', 'technical')">+ Adicionar</a>

		<!-- CANAL DE SUPORTE AO CLIENTE FINAL -->
		<h3 class="mw-90">CANAL DE SUPORTE AO CLIENTE FINAL</h3>
		<tooltip-component label="Este é o canal de contato que será disponibilizado ao cliente final." />

		<contact-form-component
			v-for="(channel, index) in channelContacts"
			:salesforce-contact-id="channel.id"
			:key="'channel' + index"
			:can-delete="index > 0"
			:form-key="index"
			:contact-filtered-list.sync="channelContacts[index]"
			:hide-full-name="true"
			:hide-phone="true"
			:show-url="true"
		/>

		<a class="more" @click="$store.dispatch('addContact', 'channel')">+ Adicionar</a>

		<!-- CONTATO PARA REEMBOLSOS E CHARGEBACKS -->
		<h3>CONTATO PARA REEMBOLSOS E CHARGEBACKS</h3>
		<contact-form-component
			v-for="(refund, index) in refundContacts"
			:salesforce-contact-id="refund.id"
			:key="'refund' + index"
			:can-delete="index > 0"
			:form-key="index"
			:hide-full-name="true"
			:hide-phone="true"
			:contact-filtered-list.sync="refundContacts[index]" />

		<a class="more" @click="$store.dispatch('addContact', 'refund')">+ Adicionar</a>

		<!-- IDENTIFICAÇÃO PEP - PESSOAS EXPOSTAS POLITICAMENTE -->
		<h3 class="mw-90">IDENTIFICAÇÃO PEP - PESSOAS EXPOSTAS POLITICAMENTE</h3>

		<tooltip-component v-b-modal.modal-pep label="Clique para expandir." />

		<p class="info">
			Você, administradores da empresa ou proprietários da empresa (familiares, parentes, na linha reta ou
			colateral, até o 2.º grau, cônjuge, companheiro, enteado, ou estreito colaborador) trabalharam nos últimos 5
			(cinco) anos para agências ou órgãos governamentais? Em caso afirmativo, especifique em quais países e qual
			a posição ocupada.
		</p>

		<b-form-group class="ml-2">
			<b-form-radio-group v-model="exposed" :options="groupOptions" name="exposed" />
		</b-form-group>

		<div v-if="exposed">
			<political-form-component
				v-for="(political, index) in politicalContacts"
				:salesforce-contact-id="political.id"
				:key="'political' + index"
				:can-delete="index > 0"
				:form-key="index"
				:contact-filtered-list.sync="politicalContacts[index]" />

			<a class="more mb-4" @click="$store.dispatch('addContact', 'political')">+ Adicionar</a>
		</div>

		<confirm-modal-component type="contact" />

		<b-modal id="modal-pep" centered hide-footer hide-header size="lg">
			<b-col class="p-2" cols="12">
				<p class="text-justify">
					<b>1. Consideram-se pessoas expostas politicamente:</b>

					<ol type="I">
						<li>os detentores de mandatos eletivos dos Poderes Executivo e Legislativo da União;</li>

						<li>os ocupantes de cargo, no Poder Executivo da União, de:
							<ol type="a">
								<li>Ministro de Estado ou equiparado;</li>
								<li>Natureza Especial ou equivalente;</li>
								<li>presidente, vice-presidente e diretor, ou equivalentes, de entidades da
									administração pública indireta; e Circular nº 3.978, de 23 de janeiro de 2020 Página
									9 de 23
								</li>
								<li>Grupo Direção e Assessoramento Superiores (DAS), nível 6, ou equivalente;</li>
							</ol>
						</li>

						<li>
							os membros do Conselho Nacional de Justiça, do Supremo Tribunal Federal, dos
							Tribunais Superiores, dos Tribunais Regionais Federais, dos Tribunais
							Regionais do Trabalho, dos Tribunais Regionais Eleitorais, do Conselho
							Superior da Justiça do Trabalho e do Conselho da Justiça Federal;
						</li>

						<li>
							os membros do Conselho Nacional do Ministério Público, o
							Procurador-Geral da República, o Vice-Procurador-Geral da República, o
							Procurador-Geral do Trabalho, o Procurador-Geral da Justiça Militar,
							os Subprocuradores-Gerais da República e os Procuradores Gerais de
							Justiça dos Estados e do Distrito Federal;
						</li>

						<li>
							os membros do Tribunal
							de Contas da União, o Procurador-Geral e os Subprocuradores-Gerais do
							Ministério Público junto ao Tribunal de Contas da União;
						</li>

						<li>
							os
							presidentes e os tesoureiros nacionais, ou equivalentes, de partidos
							políticos;
						</li>

						<li>
							os Governadores e os Secretários de Estado e do
							Distrito Federal, os Deputados Estaduais e Distritais, os presidentes,
							ou equivalentes, de entidades da administração pública indireta
							estadual e distrital e os presidentes de Tribunais de Justiça,
							Tribunais Militares, Tribunais de Contas ou equivalentes dos Estados e
							do Distrito Federal;
						</li>

						<li>
							os Prefeitos, os Vereadores, os
							Secretários Municipais, os presidentes, ou equivalentes, de entidades
							da administração pública indireta municipal e os Presidentes de
							Tribunais de Contas ou equivalentes dos Municípios.
						</li>
					</ol>

					<b>2. São também consideradas expostas politicamente as pessoas que, no exterior, sejam: </b>

					<ol type="I">
						<li>chefes de estado ou de governo;</li>
						<li>políticos de escalões superiores;</li>
						<li>ocupantes de cargos governamentais de escalões superiores;</li>
						<li>oficiais-generais e membros de escalões superiores do Poder Judiciário;</li>
						<li>executivos de escalões superiores de empresas públicas; ou</li>
						<li>dirigentes de partidos políticos.</li>
					</ol>
					
					<b>
						3. São também consideradas pessoas expostas politicamente os dirigentes de escalões superiores
						de entidades de direito internacional público ou privado.
					</b>
				</p>

				<button class="btn btn-primary w-100 mt-3" @click="$bvModal.hide('modal-pep')">Fechar</button>
			</b-col>
		</b-modal>
	</div>
</template>

<script>
import ConfirmModalComponent from "@/components/Form/ConfirmModalComponent";
import TooltipComponent from "@/components/Form/Inputs/TooltipComponent";

import OwnerFormComponent from "@/components/Form/MicroForms/OwnerFormComponent";
import RepresentativeFormComponent from "@/components/Form/MicroForms/RepresentativeFormComponent";
import ContactFormComponent from "@/components/Form/MicroForms/ContactFormComponent";
import ContractFormComponent from "@/components/Form/MicroForms/ContractFormComponent";
import PoliticalFormComponent from "@/components/Form/MicroForms/PoliticalFormComponent";

export default {
	name: "OwnersAndContactsFormComponent",
	components: {
		ConfirmModalComponent,
		TooltipComponent,
		OwnerFormComponent,
		RepresentativeFormComponent,
		ContactFormComponent,
		ContractFormComponent,
		PoliticalFormComponent,
	},
	props: { validationTrigger: Boolean },
	data() {
		return {
			groupOptions: [
				{
					text: this.$t("messages.yes"),
					value: true,
				},
				{
					text: this.$t("messages.no"),
					value: false,
				},
			],
		};
	},
	mounted() {
		this.$store.dispatch("updateStep", this.step);

		this.$emit("setReadyToSubmit", !this.$children.filter((form) => form.$v && form.$v.$invalid).length);
	},
	watch: {
		"$store.state.form.ownersAndContacts": {
			deep: true,
			handler() {
				this.$nextTick(() => {
					this.$emit(
						"setReadyToSubmit",
						!this.$children.filter((form) => form.$v && form.$v.$invalid).length,
					);
				});
			},
		},
		validationTrigger: {
			deep: true,
			handler() {
				this.$nextTick(() => {
					this.$emit(
						"setReadyToSubmit",
						!this.$children.filter((form) => form.$v && form.$v.$invalid).length,
					);
				});
			},
		},
		async step() {
			if (this.step == 2) {
				await Promise.all([
					this.$store.dispatch("updateStep", this.step),
					this.$store.dispatch("getContactsData"),
				]);
			}
		}
	},
	computed: {
		exposed: {
			get() {
				return this.$store.state.form.establishment.exposed;
			},
			set(value) {
				this.$store.commit("setEstablishment", {
					key: "exposed",
					value,
				});
				this.$nextTick(() => {
					this.$emit(
						"setReadyToSubmit",
						!this.$children.filter((form) => form.$v && form.$v.$invalid).length,
					);
				});
			},
		},
		ownerContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.owner;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "owner",
					value,
				});
			},
		},
		representativeContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.representative;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "representative",
					value,
				});
			},
		},
		contractContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.contract;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "contract",
					value,
				});
			},
		},
		billingContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.billing;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "billing",
					value,
				});
			},
		},
		technicalContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.technical;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "technical",
					value,
				});
			},
		},
		emergencyContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.emergency;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "emergency",
					value,
				});
			},
		},
		channelContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.channel;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "channel",
					value,
				});
			},
		},
		supportContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.support;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "support",
					value,
				});
			},
		},
		refundContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.refund;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "refund",
					value,
				});
			},
		},
		politicalContacts: {
			get() {
				return this.$store.state.form.ownersAndContacts.political;
			},
			set(value) {
				this.$store.commit("updateContacts", {
					key: "political",
					value,
				});
			},
		},
		step() {
			return this.$store.state.form.step;
		},
	},
};
</script>

<style lang="scss" scoped>
h3 {
	margin-bottom: 0px;
	line-height: 15px;
}

small {
	color: #c2c0bf;
	font-family: "Nunito Sans";
	font-size: 14px;
	letter-spacing: -0.14px;
	line-height: 19px;
	display: block;
}

a {
	color: #007bff !important;
	font-family: Montserrat;
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 0;
	line-height: 18px;
	text-align: right;
	cursor: pointer;
}

.info {
	color: #686361;
	font-family: "Nunito Sans";
	font-size: 14px;
	letter-spacing: 0;
	line-height: 25px;
	text-align: justify;
	margin-top: 20px;
	margin-right: 40px;
}

.more {
	width: 100% !important;
	float: right;
}

#modal-pep p,
#modal-pep li,
#modal-pep b {
	font-size: 14px;
}

@media only screen and (max-width: 1024px) {
	.info {
		text-align: left;
		margin-right: 0px;
	}
	.mw-90 {
		max-width: 85%;
	}
}
</style>
